// @flow
import * as React from 'react';
import Modal from 'react-modal';
import Group from 'entities/Group';
import GroupStore from 'groups/stores/GroupStore';
import GroupActions from 'groups/actions/GroupActions';
import UsersInviteModal from 'users/components/UsersInviteModal';

type Props = {
  group: Group,
};

type State = {
  isOpen: boolean,
  setupGroup?: ?Group,
};

// this is sily the setup flow should redirect to /classes/:code/invite
// not set something in some store and pray to god something will read it.
class GroupSignupSetupListener extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: true,
      setupGroup: GroupStore.getGroupCreatedDuringSetup(),
    };
  }

  componentDidMount() {
    GroupActions.clearGroupCreatedDuringSetup();
  }

  hide = () => {
    this.setState({ isOpen: false });
  };

  render() {
    if (!this.state.setupGroup) {
      return null;
    }

    if (this.state.setupGroup.id !== this.props.group.id) {
      return null;
    }

    return (
      <Modal isOpen={this.state.isOpen}>
        <UsersInviteModal group={this.props.group} onRequestHide={this.hide} />
      </Modal>
    );
  }
}

export default GroupSignupSetupListener;
